export const AUTH_CONFIG = {   domain: 'arupdigital.au.auth0.com',  clientId: 'wm5lqwuc5M9hYMFitIOd7w99CJ0aDsKd',   callbackUrl: 'https://parameterspace.arup.digital/callback' }



// WEBPACK FOOTER //
// ./src/Auth/auth0-variables.js